import React, { useEffect } from "react";
import { motion } from "framer-motion";

export default function ChairmanMessage({ 
  accent = "#115e32",
  pageTitle = "Secretary Message | University of Creative Technology Chittagong",
}) {
	useEffect(() => {
		document.title = pageTitle;
	}, [pageTitle]);
  return (
    <div className="relative w-full min-h-screen bg-gradient-to-b from-[#B7EAFC] via-[#F0FCFF] to-[#F0FCFF]">
      {/* Hero Section with SVG */}
      <section className="relative overflow-hidden bg-gradient-to-r from-[#B7EAFC] via-[#D6F5FE] to-[#E6FAFE]">
        {/* SVG Decorative Background */}
        <div className="absolute inset-0 flex justify-center items-center opacity-10">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="650"
            height="650"
            viewBox="0 0 650 650"
            fill="none"
            className="animate-spin-slow"
          >
            <circle
              cx="325"
              cy="325"
              r="280"
              stroke="#d4af37"
              strokeWidth="3"
              strokeDasharray="12 12"
            />
            <circle
              cx="325"
              cy="325"
              r="180"
              stroke="#2563eb"
              strokeWidth="2"
              strokeDasharray="8 8"
            />
          </svg>
        </div>

        <div className="relative container mx-auto px-6 py-20 text-center">
          <motion.h1
            initial={{ y: -40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1 }}
            className="text-4xl md:text-6xl font-extrabold text-gray-800"
          >
            Message from the{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d4af37] to-[#2563eb]">
              Secretary, BoT
            </span>
          </motion.h1>
        </div>
      </section>

      {/* VC Message Section */}
      <section className="relative container mx-auto px-6 py-16 grid md:grid-cols-2 gap-12 items-center">
        {/* VC Picture */}
        <motion.div
          initial={{ x: -50, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 1 }}
          className="flex justify-center"
        >
          <img
            src="/img/logo.png" // replace with actual VC image path
            alt="Founder"
            className="w-80 h-96 object-cover rounded-2xl shadow-lg border-4 border-[#014864]"
          />
        </motion.div>

        {/* VC Message */}
        <motion.div
          initial={{ x: 50, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 1 }}
          className="space-y-6 text-gray-700"
        >
          <h2 className="text-2xl md:text-3xl font-bold text-[#014864]">
            Md Nabiul Alam
          </h2>
          <p className="italic text-sm text-gray-500">
            Secretary, Board of Trustees<br />  
			University of Creative Technology Chittagong (UCTC)
          </p>
          <p className="leading-relaxed">
			It is a privilege to witness the continued growth and development of the University of Creative Technology Chittagong (UCTC) as we pursue our vision of becoming a leading center of excellence in higher education, research, innovation, and technological advancement. Since its establishment, UCTC has been committed to nurturing creativity, developing knowledge, and preparing future leaders who can contribute meaningfully to national and global progress.
		  </p>
          <p className="leading-relaxed">
            As Secretary of the Board of Trustees, I believe that the true strength of a university lies not only in academic achievement but also in its ability to inspire innovation, advance research, and transform lives. At UCTC, our vision extends beyond traditional education. We aspire to build a dynamic, technology-driven academic environment where students are encouraged to think critically, explore new possibilities, develop entrepreneurial mindsets, and create solutions to real-world challenges. Through quality education, industry collaboration, research, and the integration of emerging technologies, we strive to prepare graduates who are competent, ethical, adaptable, and globally competitive.
		  </p>
          <p className="leading-relaxed">
           To our prospective and current students, I encourage you to see UCTC not merely as a place to earn a degree, but as a platform to discover your potential, develop your talents, and prepare to lead in an increasingly interconnected world. Take every opportunity to learn, innovate, collaborate, and challenge conventional thinking. Your journey at UCTC should equip you not only with professional knowledge but also with the integrity, confidence, and social responsibility necessary to make a lasting difference.
          </p>
          <p className="leading-relaxed">
           I firmly believe that the future belongs to those who can combine knowledge with creativity, technology with humanity, and ambition with responsibility. Our aspiration is to position UCTC as a recognized contributor to Bangladesh's knowledge economy and as an institution that creates opportunities, advances innovation, and produces graduates capable of making an impact both nationally and internationally.

            Together, let us continue building a university that inspires excellence, embraces change, and shapes the future through education, research, and innovation. With a shared commitment to our vision, UCTC will continue striving toward a brighter, more sustainable, and prosperous future for Bangladesh and the world.
		  </p>
         
        </motion.div>
      </section>
    </div>
  );
}
